export default __webpack_public_path__ + "ed89e5b8f13d3aea8b285957932d85f6.jpg";